import { render, staticRenderFns } from "./barChartTwo.vue?vue&type=template&id=9598c664"
import script from "./barChartTwo.vue?vue&type=script&lang=js"
export * from "./barChartTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports